import AccessDenied from "components/AccessDenied";
import PageContainer from "components/PageContainer";
import { useAuth } from "contexts/auth.context";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import UserLogsDetails from "layouts/apps/components/UserLogsDetails";
import UserLogsList from "layouts/apps/components/UserLogsList";

function UserLogs() {
  const [route, setRoute] = useState(null);
  const location = useLocation();
  const { checkPermission, isTechnicalAdministrator } = useAuth();

  useEffect(() => {
    setRoute(null);
  }, [location]);

  const appPermissions = checkPermission("app");
  const canAccessUserLogs = appPermissions?.get && isTechnicalAdministrator;

  if (
    Object.keys(appPermissions).filter((key) => appPermissions[key]).length ===
    0
  ) {
    return <AccessDenied type="page" />;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar customRoute={route} />

      <PageContainer>
        <Routes>
          <Route
            index
            element={<UserLogsList canAccess={canAccessUserLogs} />}
          />
          <Route
            path=":userId"
            element={<UserLogsDetails canAccess={canAccessUserLogs} />}
          />
        </Routes>
      </PageContainer>

      <Footer />
    </DashboardLayout>
  );
}

export default UserLogs;
